:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  display: grid;
}

.expandable-button {
  justify-content: center;
  align-self: center;
}

.ch-disabled {
  pointer-events: none;
}

::slotted([slot=action]) {
  pointer-events: none;
}

ch-popover {
  --ch-popover-separation-x: var(--ch-action-menu-separation-x);
  --ch-popover-separation-y: var(--ch-action-menu-separation-y);
}
ch-popover:not(.hydrated) {
  display: none;
  opacity: 0;
}

.action {
  text-align: start;
  --ch-action-menu-item-start-img: var(--ch-start-img--base);
  --ch-action-menu-item-end-img: var(--ch-end-img--base);
}
.action.start-img--hover:hover {
  --ch-action-menu-item-start-img: var(--ch-start-img--hover);
}
.action.end-img--hover:hover {
  --ch-action-menu-item-end-img: var(--ch-start-end--hover);
}
.action.start-img--active:active {
  --ch-action-menu-item-start-img: var(--ch-start-img--active);
}
.action.end-img--active:active {
  --ch-action-menu-item-end-img: var(--ch-start-end--active);
}
.action.start-img--focus:focus {
  --ch-action-menu-item-start-img: var(--ch-start-img--focus);
}
.action.end-img--focus:focus {
  --ch-action-menu-item-end-img: var(--ch-end-img--focus);
}
.action.start-img--disabled.ch-disabled {
  --ch-action-menu-item-start-img: var(--ch-start-img--disabled);
}
.action.end-img--disabled.ch-disabled {
  --ch-action-menu-item-end-img: var(--ch-end-img--disabled);
}

.pseudo-img--start::before,
.pseudo-img--end::before {
  content: "";
  display: block;
  inline-size: var(--ch-action-menu-item__image-size);
  block-size: var(--ch-action-menu-item__image-size);
  min-inline-size: var(--ch-action-menu-item__image-size);
}

.start-img-type--background::before {
  background: no-repeat center/var(--ch-action-menu-item__background-image-size) var(--ch-action-menu-item-start-img);
}

.end-img-type--background::after {
  background: no-repeat center/var(--ch-action-menu-item__background-image-size) var(--ch-action-menu-item-end-img);
}

.start-img-type--mask::before {
  -webkit-mask: no-repeat center/var(--ch-action-menu-item__background-image-size) var(--ch-action-menu-item-start-img);
  background-color: currentColor;
}

.end-img-type--mask::after {
  -webkit-mask: no-repeat center/var(--ch-action-menu-item__background-image-size) var(--ch-action-menu-item-end-img);
  background-color: currentColor;
}

.content {
  inline-size: 100%;
}